import MDSpinner from "react-md-spinner";
import Switch from "../../../Components/Switch";
import { useContext, useState } from "react";
import { AppContext } from "../../../Util/contexts/AppContext";

const DisableAnimations = () => {
  const { userData, setUserData, route, displayAuthenticationError } =
    useContext(AppContext);
  const [disableAnimationsLoading, setDisableAnimationsLoading] =
    useState(false);

  const disableAnimationsHandler = async () => {
    let tempUserData = structuredClone(userData);
    tempUserData.AnimationsDisabled = !tempUserData.AnimationsDisabled;

    let body = JSON.stringify({
      CustomerId: tempUserData.CustomerId,
      AnimationsDisabled: tempUserData.AnimationsDisabled,
    });
    setUserData(tempUserData);
    setDisableAnimationsLoading(true);
    await fetch(`${route}/toggleanimationsdisable.webapi`, {
      method: "POST",
      headers: {
        Token: userData.Token,
        "Content-Type": "text/plain",
      },
      body: body,
    })
      .then((response) => {
        if (response.ok) {
          return response.text();
        } else if (response.status === 401) {
          return displayAuthenticationError();
        } else {
          throw new Error("Error");
        }
      })
      .then((response) => {})
      .catch((error) => {
        tempUserData.AnimationsDisabled = !tempUserData.AnimationsDisabled;
        setUserData(tempUserData);
        console.log(error);
        // logFetchError(error, null, userData, 'disableAnimationsHandler')
      })
      .finally(() => {
        setDisableAnimationsLoading(false);
      });
  };

  return (
    <div className="accountSettingsCard">
      <h3 className="accountSettingsCardTitle">Disable Animations</h3>
      <p className="accountSettingsToggleDescription">
        If you'd like to disable animations throughout the application, you can
        toggle that here.
      </p>
      <Switch
        value={userData.AnimationsDisabled}
        onClick={disableAnimationsHandler}
        customClass="accountSettingsToggle"
      />
      {disableAnimationsLoading && (
        <div className="accountSettingsCardLoaderOverlay">
          <MDSpinner size={35} singleColor={"#fff"} />
        </div>
      )}
    </div>
  );
};

export default DisableAnimations;
